/* eslint-disable require-jsdoc */
import React from 'react';
import { Provider } from 'react-redux';
import AppProviders from './providers/AppProviders';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './constants/authConfig';
import store from './store';

function App() {
  return (
    <Provider store={store}>
      <MsalProvider instance={msalInstance}>
        <AppProviders />
      </MsalProvider>
    </Provider>
  );
}

export default App;
